/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { deleteApiVatexemptionV1Id } from '../fn/vat-exemption/delete-api-vatexemption-v-1-id';
import { DeleteApiVatexemptionV1Id$Params } from '../fn/vat-exemption/delete-api-vatexemption-v-1-id';
import { getApiVatexemptionV1Id$Json } from '../fn/vat-exemption/get-api-vatexemption-v-1-id-json';
import { GetApiVatexemptionV1Id$Json$Params } from '../fn/vat-exemption/get-api-vatexemption-v-1-id-json';
import { getApiVatexemptionV1Id$Plain } from '../fn/vat-exemption/get-api-vatexemption-v-1-id-plain';
import { GetApiVatexemptionV1Id$Plain$Params } from '../fn/vat-exemption/get-api-vatexemption-v-1-id-plain';
import { postApiVatexemptionV1$Json } from '../fn/vat-exemption/post-api-vatexemption-v-1-json';
import { PostApiVatexemptionV1$Json$Params } from '../fn/vat-exemption/post-api-vatexemption-v-1-json';
import { postApiVatexemptionV1$Plain } from '../fn/vat-exemption/post-api-vatexemption-v-1-plain';
import { PostApiVatexemptionV1$Plain$Params } from '../fn/vat-exemption/post-api-vatexemption-v-1-plain';
import { postApiVatExemptionV1Create$Json } from '../fn/vat-exemption/post-api-vat-exemption-v-1-create-json';
import { PostApiVatExemptionV1Create$Json$Params } from '../fn/vat-exemption/post-api-vat-exemption-v-1-create-json';
import { postApiVatExemptionV1Create$Plain } from '../fn/vat-exemption/post-api-vat-exemption-v-1-create-plain';
import { PostApiVatExemptionV1Create$Plain$Params } from '../fn/vat-exemption/post-api-vat-exemption-v-1-create-plain';
import { putApiVatexemptionV1Id$Json } from '../fn/vat-exemption/put-api-vatexemption-v-1-id-json';
import { PutApiVatexemptionV1Id$Json$Params } from '../fn/vat-exemption/put-api-vatexemption-v-1-id-json';
import { putApiVatexemptionV1Id$Plain } from '../fn/vat-exemption/put-api-vatexemption-v-1-id-plain';
import { PutApiVatexemptionV1Id$Plain$Params } from '../fn/vat-exemption/put-api-vatexemption-v-1-id-plain';
import { VatExemptionModel } from '../models/vat-exemption-model';
import { VatExpemtionsResponseModel } from '../models/vat-expemtions-response-model';

@Injectable({ providedIn: 'root' })
export class VatExemptionService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `postApiVatexemptionV1()` */
  static readonly PostApiVatexemptionV1Path = '/private/v1/vat-exemptions';

  /**
   * Retrive the list all the existing vat exemptions available the database asynchronously.
   *
   * Retrive the list all the existing vat exemptions available the database asynchronously
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiVatexemptionV1$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiVatexemptionV1$Plain$Response(params?: PostApiVatexemptionV1$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<VatExpemtionsResponseModel>> {
    return postApiVatexemptionV1$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrive the list all the existing vat exemptions available the database asynchronously.
   *
   * Retrive the list all the existing vat exemptions available the database asynchronously
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiVatexemptionV1$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiVatexemptionV1$Plain(params?: PostApiVatexemptionV1$Plain$Params, context?: HttpContext): Observable<VatExpemtionsResponseModel> {
    return this.postApiVatexemptionV1$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<VatExpemtionsResponseModel>): VatExpemtionsResponseModel => r.body)
    );
  }

  /**
   * Retrive the list all the existing vat exemptions available the database asynchronously.
   *
   * Retrive the list all the existing vat exemptions available the database asynchronously
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiVatexemptionV1$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiVatexemptionV1$Json$Response(params?: PostApiVatexemptionV1$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<VatExpemtionsResponseModel>> {
    return postApiVatexemptionV1$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrive the list all the existing vat exemptions available the database asynchronously.
   *
   * Retrive the list all the existing vat exemptions available the database asynchronously
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiVatexemptionV1$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiVatexemptionV1$Json(params?: PostApiVatexemptionV1$Json$Params, context?: HttpContext): Observable<VatExpemtionsResponseModel> {
    return this.postApiVatexemptionV1$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<VatExpemtionsResponseModel>): VatExpemtionsResponseModel => r.body)
    );
  }

  /** Path part for operation `getApiVatexemptionV1Id()` */
  static readonly GetApiVatexemptionV1IdPath = '/private/v1/vat-exemptions/{id}';

  /**
   * Retrieves a VAT exemption entity by its unique id.
   *
   * Retrieves a VAT exemption entity by its unique id.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getApiVatexemptionV1Id$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiVatexemptionV1Id$Plain$Response(params: GetApiVatexemptionV1Id$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<VatExemptionModel>> {
    return getApiVatexemptionV1Id$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves a VAT exemption entity by its unique id.
   *
   * Retrieves a VAT exemption entity by its unique id.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getApiVatexemptionV1Id$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiVatexemptionV1Id$Plain(params: GetApiVatexemptionV1Id$Plain$Params, context?: HttpContext): Observable<VatExemptionModel> {
    return this.getApiVatexemptionV1Id$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<VatExemptionModel>): VatExemptionModel => r.body)
    );
  }

  /**
   * Retrieves a VAT exemption entity by its unique id.
   *
   * Retrieves a VAT exemption entity by its unique id.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getApiVatexemptionV1Id$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiVatexemptionV1Id$Json$Response(params: GetApiVatexemptionV1Id$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<VatExemptionModel>> {
    return getApiVatexemptionV1Id$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves a VAT exemption entity by its unique id.
   *
   * Retrieves a VAT exemption entity by its unique id.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getApiVatexemptionV1Id$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiVatexemptionV1Id$Json(params: GetApiVatexemptionV1Id$Json$Params, context?: HttpContext): Observable<VatExemptionModel> {
    return this.getApiVatexemptionV1Id$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<VatExemptionModel>): VatExemptionModel => r.body)
    );
  }

  /** Path part for operation `putApiVatexemptionV1Id()` */
  static readonly PutApiVatexemptionV1IdPath = '/private/v1/vat-exemptions/{id}';

  /**
   * Updates an existing VAT exemption entity in the database.
   *
   * Updates an existing VAT exemption entity in the database.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `putApiVatexemptionV1Id$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putApiVatexemptionV1Id$Plain$Response(params: PutApiVatexemptionV1Id$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<VatExemptionModel>> {
    return putApiVatexemptionV1Id$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates an existing VAT exemption entity in the database.
   *
   * Updates an existing VAT exemption entity in the database.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `putApiVatexemptionV1Id$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putApiVatexemptionV1Id$Plain(params: PutApiVatexemptionV1Id$Plain$Params, context?: HttpContext): Observable<VatExemptionModel> {
    return this.putApiVatexemptionV1Id$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<VatExemptionModel>): VatExemptionModel => r.body)
    );
  }

  /**
   * Updates an existing VAT exemption entity in the database.
   *
   * Updates an existing VAT exemption entity in the database.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `putApiVatexemptionV1Id$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putApiVatexemptionV1Id$Json$Response(params: PutApiVatexemptionV1Id$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<VatExemptionModel>> {
    return putApiVatexemptionV1Id$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates an existing VAT exemption entity in the database.
   *
   * Updates an existing VAT exemption entity in the database.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `putApiVatexemptionV1Id$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putApiVatexemptionV1Id$Json(params: PutApiVatexemptionV1Id$Json$Params, context?: HttpContext): Observable<VatExemptionModel> {
    return this.putApiVatexemptionV1Id$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<VatExemptionModel>): VatExemptionModel => r.body)
    );
  }

  /** Path part for operation `deleteApiVatexemptionV1Id()` */
  static readonly DeleteApiVatexemptionV1IdPath = '/private/v1/vat-exemptions/{id}';

  /**
   * Deletes a VAT exemption entity by its unique code.
   *
   * Deletes a VAT exemption entity by its unique code.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteApiVatexemptionV1Id()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteApiVatexemptionV1Id$Response(params: DeleteApiVatexemptionV1Id$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteApiVatexemptionV1Id(this.http, this.rootUrl, params, context);
  }

  /**
   * Deletes a VAT exemption entity by its unique code.
   *
   * Deletes a VAT exemption entity by its unique code.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteApiVatexemptionV1Id$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteApiVatexemptionV1Id(params: DeleteApiVatexemptionV1Id$Params, context?: HttpContext): Observable<void> {
    return this.deleteApiVatexemptionV1Id$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `postApiVatExemptionV1Create()` */
  static readonly PostApiVatExemptionV1CreatePath = '/private/v1/vat-exemptions/Create';

  /**
   * Creates a new VAT exemption entity in the database.
   *
   * Creates a new VAT exemption entity in the database.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiVatExemptionV1Create$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiVatExemptionV1Create$Plain$Response(params?: PostApiVatExemptionV1Create$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<VatExemptionModel>> {
    return postApiVatExemptionV1Create$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a new VAT exemption entity in the database.
   *
   * Creates a new VAT exemption entity in the database.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiVatExemptionV1Create$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiVatExemptionV1Create$Plain(params?: PostApiVatExemptionV1Create$Plain$Params, context?: HttpContext): Observable<VatExemptionModel> {
    return this.postApiVatExemptionV1Create$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<VatExemptionModel>): VatExemptionModel => r.body)
    );
  }

  /**
   * Creates a new VAT exemption entity in the database.
   *
   * Creates a new VAT exemption entity in the database.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiVatExemptionV1Create$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiVatExemptionV1Create$Json$Response(params?: PostApiVatExemptionV1Create$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<VatExemptionModel>> {
    return postApiVatExemptionV1Create$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a new VAT exemption entity in the database.
   *
   * Creates a new VAT exemption entity in the database.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiVatExemptionV1Create$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiVatExemptionV1Create$Json(params?: PostApiVatExemptionV1Create$Json$Params, context?: HttpContext): Observable<VatExemptionModel> {
    return this.postApiVatExemptionV1Create$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<VatExemptionModel>): VatExemptionModel => r.body)
    );
  }

}
